var baJS = {
	int:function(){
		console.log("Ready to go!");
	},
	posts:{
		total:0,
		loaded:0,
		hidden:0,
		per:6,
		search:'',
		stash:'',
		searchTime:0,
		postData:"",
		popularData:"",
		sortingTimeout:null,
		init:function(){
			if($("#ba-post-stage .ba--pgitem").length > 0){
				this.postData = $.trim($("#ba-post-stage").html().replace("\n", '').replace("\t", ''));
				this.popularData = $.trim($("#ba-post-stash").html().replace("\n", '').replace("\t", ''));
				$(".ba-post--loadmore").show();
				if($("#ba-post-stage .ba--pgitem[aria-hidden=true]").length === 0){
					$(".ba-post--loadmore").hide();
				}
				this.calcDelta();
			}
		},
		stashPosts:function(){
			if($("#ba-post-stage").length > 0){
				this.stash = $("#ba-post-stage").html();
			}
		},
		reviveStash:function(){
			$("#home-search").val('');
			$("#ba-post-stage").html(this.stash);
			$("#home-search-form .clear-search").fadeOut(400);
			this.init();
		},
		calcDelta:function(){
			this.total = $("#ba-post-stage .ba--pgitem").length;
			this.loaded = this.total - $("#ba-post-stage .ba--pgitem[aria-hidden=true]").length;
			this.hidden = this.total - this.loaded;
			if(this.hidden <= 0){
				$(".ba-post--loadmore").hide();	 
			}
		},
		calcPer:function(){
			if(responder.curZindex === 10){ 
				this.per = 3;
			} else if(responder.curZindex === 8){
				this.per = 4;			
			} else {
				this.per = 6;
			}
		},
		loadMore:function(){
			console.log("Loading more...");
			$("#ba-post-stage").find(".ba--pgitem").removeClass("first-focus");
			this.calcPer();
			if(this.hidden > 0){
				var hiddenPosts = $("#ba-post-stage").find(".ba--pgitem[aria-hidden=true]").slice(0, this.per);
				var scrollTarget = $("#ba-post-stage").find(".ba--pgitem[aria-hidden=false]").last();
				var scrollOffset = scrollTarget.height();
				var totalToShow = hiddenPosts.length;
				if(totalToShow > 0){
					var delay = 0;
					var fadeDelay = 150;
					hiddenPosts.each(function(){
						var item = $(this);
						//item.css("display", "block");
						item.attr("aria-hidden", "false");
						setTimeout(function(){ item.removeClass("hidden") }, delay);
						//if(delay == 0){ 
							//item.addClass("first-focus");
						//}
						delay += fadeDelay;
					});
					setTimeout(function(){ 
						if($("#ba-post-stage").find(".ba--pgitem[aria-hidden=true]").length <= 0){
							$(".ba-post--loadmore").fadeOut(600);
						}
					}, delay + 100);
					$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
					//$("#ba-post-stage").find(".ba--pgitem.first-focus").focus();
				} else {
					$(".ba-post--loadmore").fadeOut(600);
				}
			}
		},
		changeSort:function(type){
			var newsorteddata;
			switch(type){
				case "t":
					newsorteddata = this.postData
					break;
				case "p":
					newsorteddata = this.popularData;
					break;
			}
			$("#ba-post-stage").html('<div class="search-context" tabindex="0"><p class="bds--small">Sorting<span>.</span><span>.</span><span>.</span></p></div>');
			clearTimeout(this.sortingTimeout);
			this.sortingTimeout = setTimeout(function(){
				$("#ba-post-stage").html(newsorteddata);
				$(".ba-post--loadmore").show();
				if($("#ba-post-stage .ba--pgitem[aria-hidden=true]").length === 0){
					$(".ba-post--loadmore").hide();
				}
			}, 400);
		}
	},
	searchPage:{
		q:null,
		postData:[],
		per:6,
		hidden:0,
		searchTime:0,
		topicID:0,
		sortBy:'recent',
		sorttype:"t",
		sortingTimeout:null,
		scrollNextSearch:true,
		init:function(){
			if($("#ba-post-stage .ba--pgitem").length > 0){
				$(".ba-post--loadmore").show();
				//this.calcDelta();
			}
		},
		fetchResults:function(){
			var thisobj = this;
      var searchTerm = thisobj.q;
			$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Searching<span>.</span><span>.</span><span>.</span></p></div>');
			//$("#home-search-form .clear-search").css("display", "block");
			//$(".search-context").focus();
			if(this.scrollNextSearch){
				$('html, body').animate({scrollTop: $("#ba-page--search-form").offset().top - 50 - $("header").height() }, 400);
			} else {
				this.scrollNextSearch = true;
			}
			$(".ba-post--loadmore").hide();
			this.searchTime = new Date().getTime();
      $.ajax({
				type: 'POST',
				url: ajaxfullurl,
				data: {
					'action': 'blockadvisors_post_search',
					'topicID' : this.topicID,
					'sortBy' : this.sortBy,
					'search' : searchTerm,
				}, 
				success: function (result) {
					thisobj.postData = result.posts;
					thisobj.buildResults();
					$("#most-recent").prop('checked', true);
				},
				error: function () {
					$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Something went wrong. Try again or <a href="javascript:void(0)" class="action--reset-search">Show All</a></p></div>');
					$(".ba-post--loadmore").hide();
				}
      });
		},
		buildResults:function(){
			var thisobj = this;
			var returndata = [];
			var totalresults = thisobj.postData.length;
			var monthToArray = ["January","February","March","April","May","June","July","August","September","October","November","December"];
			
			for(var i=0; i < totalresults; i++){
				var ariaHidden = 'false';
				if(i >= 6){
					ariaHidden = 'true';
				}
				var articleDate = new Date(parseInt(thisobj.postData[i].t) * 1000);
				var articleDateString = monthToArray[articleDate.getMonth()]+' '+articleDate.getDate()+', '+articleDate.getFullYear();
				var articleDateAttr = articleDate.toISOString().split('T');
				returndata.push(''+
					'<a href="'+thisobj.postData[i].url+'" data-click=\'{"loc":"b","nm":"'+thisobj.postData[i].dt+'"}\' class="ba--pgitem" aria-hidden="'+ariaHidden+'">'+
						'<span class="category-label">'+thisobj.postData[i].cat+'<time datetime="'+articleDateAttr[0]+'">&nbsp;&nbsp;&bull;&nbsp; '+articleDateString+'</time></span>'+
						'<h2 class="post-title bds--small">'+thisobj.postData[i].title+'</h2>'+
						'<p>'+thisobj.postData[i].ex+'</p>'+
					'</a>');				
			}
			var nowish =  new Date().getTime();
			var remainder = Math.floor(500 - (nowish - this.searchTime));
			$("#ba-search-count span:first-of-type").text(totalresults);
			this.hidden = totalresults - this.per;
			if(totalresults == 1){
				$(".is-the-count-plural").hide();
			} else {
				$(".is-the-count-plural").show();
			}
			setTimeout(function(){
				if(returndata.length > 0){
					$(".ba-search--page--results").html(returndata.join("\r"));
					thisobj.init();
					$(".search-result-metrics").slideDown(200);
					//$(".ba-search--page--results").find(".ba--pgitem:first-of-type").focus();
				} else {
					$(".search-result-metrics").slideUp(200);
					$(".ba-search--page--results").html($("#search-page-no-results").html());
				}
				if(returndata.length - thisobj.per > 0){
					$(".ba-post--loadmore").show();
				} else {
					$(".ba-post--loadmore").hide();
				}
			}, remainder);
		},
		calcPer:function(){
			this.per = 3;
			/*
			if(responder.curZindex === 10){ 
				this.per = 3;
			} else {
				this.per = 3;
			}
			*/
		},
		loadMore:function(){
			console.log("Loading more...");
			$(".ba-search--page--results").find(".ba--pgitem").removeClass("first-focus");
			this.calcPer();
			var thePer = this.per;
			if(this.hidden > 0){
				var hiddenPosts = $(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").slice(0, this.per);
				var scrollTarget = $(".ba-search--page--results").find(".ba--pgitem[aria-hidden=false]").last();
				var scrollOffset = scrollTarget.height();
				var totalToShow = hiddenPosts.length;
				if(totalToShow > 0){
					var delay = 0;
					var fadeDelay = 150;
					hiddenPosts.each(function(){
						var item = $(this);
						setTimeout(function(){ item.attr("aria-hidden", "false") }, delay);
						if(delay == 0){ 
							item.addClass("first-focus");
						}
						delay += fadeDelay;
					});
					setTimeout(function(){ 
						if($(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").length <= 0){
							$(".ba-post--loadmore").fadeOut(600);
						}
					}, delay + 100);
					if(this.scrollNextSearch){
						$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
					} else {
						this.scrollNextSearch = true;
					}
					//$(".ba-search--page--results").find(".ba--pgitem.first-focus").focus();
					//console.log($(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").length, thePer);
				} else {
					$(".ba-post--loadmore").fadeOut(600);
				}
			}
		},
		changeSort:function(){
			/*
			var allposts = $(".ba-search--page--results a");
			if(allposts.length === 0){
				return false;
			}
			$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Sorting<span>.</span><span>.</span><span>.</span></p></div>');
			var thesort = this.sorttype;
			allposts.sort(function(a, b){
				return ($(b).data(thesort)) < ($(a).data(thesort)) ? -1 : 1;
			});
			clearTimeout(this.sortingTimeout);
			this.sortingTimeout = setTimeout(function(){
				$(".ba-search--page--results").html(allposts);
			}, 400);
			*/
		}
	},
	alertBar:{
		init:function(){
			//Measure height and adjust
			this.adjust();
			//Readjust if closed.
			responder.resizeCallbacks.push(function(){ baJS.alertBar.adjust(); });
		},
		adjust:function(){
			var ht = $("header").height();
			$(".header--ghost").height(ht);
			$(".ba-jump-location").css({transform:"translateY(-"+ht+"px)"});
		},
		adjustSlide:function(){
			var ht = $("header").height();
			$(".header--ghost").animate({height:ht}, 200);
			$(".ba-jump-location").css({transform:"translateY(-"+(ht)+"px)"});
		}
	},
	fixDataTrack:{
		init:function() {
			var ewtfLeftBlockTrack = $('.wp-block-create-block-hrb-expat-ways-to-file .wtf-column--left a').attr('data-track');
			var ewtfLeftRevisedTrack = ewtfLeftBlockTrack.replace(/\'/g, '"');
			$('.wp-block-create-block-hrb-expat-ways-to-file .wtf-column--left a').attr('data-track', ewtfLeftRevisedTrack);

			var ewtfRightBlockTrack = $('.wp-block-create-block-hrb-expat-ways-to-file .wtf-column--right a').attr('data-track');
			var ewtfRightRevisedTrack = ewtfRightBlockTrack.replace(/\'/g, '"');
			$('.wp-block-create-block-hrb-expat-ways-to-file .wtf-column--right a').attr('data-track', ewtfRightRevisedTrack);
		}
	}
};

$(document)
.ready(function(){
	responder.init();
	baJS.int();
	baJS.posts.init();
	baJS.posts.stashPosts();
	baJS.alertBar.init();
	baJS.fixDataTrack.init();
})
.on("click", ".action--open-mobile-menu", function(e){
	e.preventDefault();
	$("html").toggleClass("mobile-menu-open");
	if($("html").hasClass("mobile-menu-open")){
		$("html").removeClass("search-open");
		$(this).attr("aria-expanded", true);
		$("header").modalTabbing();
	} else {
		$("header").off('keydown');
		$(this).attr("aria-expanded", false);
	}
})
.on("keypress", ".action--open-mobile-menu", function(e){
	e.preventDefault();
	var charCode = e.keyCode || e.which;
	console.log("spacebar", charCode);
	if (charCode === 32){
		$(".action--open-mobile-menu").trigger("click");
	}
})
.on("click", ".action--open-search", function(e){
	e.preventDefault();
	$("html").toggleClass("search-open");
	if($("html").hasClass("search-open")){
		$(this).attr("aria-expanded", true);
		$(".ba-search-box").modalTabbing();
	} else {
		$(".ba-search-box").off('keydown');
		$(this).attr("aria-expanded", false);
	}
})
.on("keypress", ".action--open-search", function(e){
	e.preventDefault();
	var charCode = e.keyCode || e.which;
	console.log("spacebar", charCode);
	if (charCode === 32){
		$(".action--open-search").trigger("click")
	}
})
.on("keypress", ".action--close-search", function(e){
	e.preventDefault();
	var charCode = e.keyCode || e.which;
	if (charCode === 32){
		$(".action--close-search").trigger("click");
	}
})
.on("click", ".action--close-search", function(e){
	e.preventDefault();
	$("html").removeClass("search-open");
	$(".ba-search-box").off('keydown');
})
.on("submit", "#ba-header--search-form", function(e){
	e.preventDefault();
	var thesearch = $(this).find("input[type=search]").val().replace(/[^0-9a-zA-Z\s]/g, "");
	thesearch = encodeURIComponent(thesearch);
	window.open(searchfullurl+"?q="+thesearch, "_self");
	//alert("Take the query and move to search results page: "+thesearch);
})
.on("submit", "#ba-page--search-form.interactive--search", function(e){
	e.preventDefault();
	var thesearch = $(this).find("input[type=search]").val();
	baJS.searchPage.q = thesearch;
	baJS.searchPage.fetchResults();
})
.on("click", ".action--load-more-posts", function(e){
	e.preventDefault();
	baJS.posts.loadMore();
})
.on("click", ".action--load-more-search-posts", function(e){
	e.preventDefault();
	baJS.searchPage.loadMore();
})
.on("change", "#expat-search-bytopic", function(e){
	e.preventDefault();
	baJS.searchPage.topicID = parseInt($(this).val());
	baJS.searchPage.fetchResults();
})
.on("change", "#expat-search-sort", function(e){
	e.preventDefault();
	baJS.searchPage.sortBy = $(this).val();
	baJS.searchPage.fetchResults();
})
.on("click", ".action--search--reset-filters", function(e){
	e.preventDefault();

	if($("body").is(".category")) {
		baJS.searchPage.sortBy = 'recent';
		baJS.searchPage.q = '';
		$("#expat-search-sort").val('recent');
		$("#ba-page-search-field").val('');
	} else {
		baJS.searchPage.topicID = 0;
		baJS.searchPage.sortBy = 'recent';
		baJS.searchPage.q = '';
		$("#expat-search-bytopic").val(0);
		$("#expat-search-sort").val('recent');
		$("#ba-page-search-field").val('');
	}
	
	baJS.searchPage.fetchResults();
})
.on('click', '[data-track]', function(){
	var trackingObj = JSON.parse( $(this).attr('data-track') );
	HRBData.digital_data.loc = trackingObj.loc;
	HRBData.digital_data.nm = trackingObj.nm;
	try {     
		_satellite.track('regular_click');
		} catch (e) {}
})
.on("click", ".ba-alert--close", function(e){
	e.preventDefault();
	//baJS.alertBar.init();
	$(".ba-alert").slideUp(200, function(){
		baJS.alertBar.adjustSlide();
	});
})
.on("keypress", ".action--click-explore-categories", function(e){
	if(responder.curZindex === 10){ 
		e.preventDefault();
		var charCode = e.keyCode || e.which;
		if (charCode === 32){
			$(".action--click-explore-categories").trigger("click");
		}
	}
})
.on("click", ".action--click-explore-categories", function(e){
	if(responder.curZindex >= 8){
		e.preventDefault();
		$("html").toggleClass("mobile-cats-open");
		if($("html").hasClass("mobile-cats-open")){
			$(this).attr("aria-expanded", true);
			$(".ba-catbar--mobile-cats").modalTabbing();
		} else {
			$(".ba-catbar--mobile-cats").off('keydown');
			$(this).attr("aria-expanded", false);
		}
	}
})
.on("keypress", ".action--close-mobile-cats", function(e){
	e.preventDefault();
	var charCode = e.keyCode || e.which;
	if (charCode === 32){
		$(".action--close-mobile-cats").trigger("click");
	}
})
.on("click", ".action--close-mobile-cats", function(e){
	e.preventDefault();
	$("html").removeClass("mobile-cats-open");
	$(".ba-catbar--mobile-cats").off('keydown');
})
;

// trap focus within mobile menu
(function ($) {
  $.fn.modalTabbing = function () {
    console.log("focus trapping...");
    var tabbing = function (jqSelector) {
      
      //Find all possible tabbable inputs inside the modal.
      var inputs = $(jqSelector).find('a, input, button').filter(':visible').not(':disabled');

      //Focus to first element in the container.
      inputs.first().focus();

      $(jqSelector).on('keydown', function (e) {
        if (e.which === 9) {

          var inputs = $(jqSelector).find('a, input, button').filter(':visible').not(':disabled');

          /*redirect last tab to first input*/
          if (!e.shiftKey) {
            if (inputs[inputs.length - 1] === e.target) {
              e.preventDefault();
              inputs.first().focus();
            }
          }
          /*redirect first shift+tab to last input*/
          else {
            if (inputs[0] === e.target) {
              e.preventDefault();
              inputs.last().focus();
            }
          }
        }
      });
    };

    return this.each(function () {
      tabbing(this);
    });

  };
})(jQuery);

var responder = {
	isopen:false,
	curZindex:1,
	init:function(){
    $(window).resize(function(){ responder.resized(); });
    window.onorientationchange = function (event){ responder.resized(); }
		responder.resized();
  },
  resizeCallbacks:[function(){ responder.setFrameWidths(); }],
	resized:function(){
		var thisobj = this;
		if(thisobj.resizeCallbacks.length > 0){
			for(var i=0; i < thisobj.resizeCallbacks.length; i++){
				try {
					responder.resizeCallbacks[i]();
				}
				catch(err){
					console.log('Function does not exist');
				}
			}
		}
	},
	setFrameWidths:function(){
		this.curZindex = parseInt($("#responder").css('z-index'));
		if($("html").hasClass("mobile-menu-open") && this.curZindex < 8){
			$("header").off('keydown');
			$("html").removeClass("mobile-menu-open");
		}
	},
};
